import Vue from "vue";

function initializeLanguageControl() {
	if (!ceresStore.state.lazyComponent.components["shipping-country-select"]) {
		ceresStore.dispatch("loadComponent", "shipping-country-select");
	}
}

Vue.directive("open-language-control", {
	bind(el, binding) {
		el.addEventListener(
			"mouseover",
			function() {
				initializeLanguageControl();
			},
			{ once: true }
		);
		el.onclick = function(event) {
			initializeLanguageControl();
		};
	}
});
